import styled from 'styled-components';
import MenuLine from '../MenuLine';

export const PurchaseWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding-top: 20px;
  max-width: 233px;
  width: 100%;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    padding: 15px 20px;
  }
`;

export const HeaderTypography = styled.div`
  color: ${props => props.theme.carvana.blue.dark};
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 5px;
  text-transform: uppercase;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    font-size: 14px;
    white-space: nowrap;
  }
`;

export const StyledMenuLine = styled(MenuLine)`
  display: none;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    display: block;
  }
`;
